import smoothscroll from 'smoothscroll-polyfill';
smoothscroll.polyfill();

export async function scrollToTopOfElement(
  element
) {
  return new Promise((resolve) => {
    setTimeout(()=> resolve(), 1000); //ensure resolve

    if (element == null) resolve();
    if (element) {
      const yOffset = 0;
      const y =
        element.getBoundingClientRect().top + window.pageYOffset + yOffset;

      const onScroll = function () {
        const cantScrollTo =
          window.innerHeight > document.documentElement.scrollHeight - y;
        const doneScrolling = window.pageYOffset.toFixed() === y.toFixed();

        if (cantScrollTo || doneScrolling) {
          window.removeEventListener('scroll', onScroll);
          resolve();
        }
      };

      window.addEventListener('scroll', onScroll);
      onScroll();
      window.scroll({
        top: y,
        behavior: 'smooth',
      });
    }
  });
}